import React, { useContext } from 'react';

import { AddIcon, CloseIcon, SubtractIcon } from '$partials/icon';
import { ModalContext } from '$contexts/modal.jsx';
import { Button } from '$partials/ui';
import { Carousel, CarouselNavigation, CarouselSlide, CarouselWrapper } from '$partials/base/carousel';

import { useBreakpoint } from '$hooks/events';
import { TransformComponent, TransformWrapper } from 'react-zoom-pan-pinch';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modals.d.ts').FloorplanModal}
 */
const FloorplanModal = ({
    images
}) => {
    const { handleModal } = useContext(ModalContext);
    const breakpoint = useBreakpoint(['main', 'sm', 'md'], 'main');
    // const { height } = useViewport();
    // const maxHeight = height - 215;

    return (
        <Carousel swiperConfig={{
            slidesPerView: 1,
            simulateTouch: false,
            spaceBetween: 0,
            speed:0,
            breakpoints: {
                640: {
                    slidesPerView: 1
                },
                1024: {
                    slidesPerView: 1
                }
            },
        }}>
            <div className={'fixed left-0 top-0 height-100 width-100 border-0 m0 p0 overflow-hidden bg-grey z3'}>
                <div
                    className='flex flex-row-reverse width-100 justify-between absolute top-0 px5 mt5 md-flex-col md-width-0 md-height-100 right right-0 md-mt0 md-px0 md-mr6 z4 pointer-events-none'>
                    <div className='md-flex justify-end'>
                        <Button
                            aria-label='Close'
                            as='button'
                            className='bg-black py2 px3 md-px5 md-py4 md-mt6 white pointer-events-auto items-center type-style-5 uppercase'
                            look='button'
                            onClick={() => {
                                handleModal();
                            }}
                            renderIcon={<CloseIcon className='ml3'/>}>
                            Close
                        </Button>
                    </div>
                    {images?.length !== 1 && (
                        <div className='flex flex-col mt-auto md-mb6 md-absolute-center-y right right-0 pointer-events-auto'>
                            <CarouselNavigation
                                floorplan={true}
                                look={breakpoint === 'md' ? 'col' : 'row'} />
                        </div>
                    )}
                </div>

                <CarouselWrapper
                    className='swiper-wrapper flex flex-col'>
                    {images?.map((item, i) => {
                        return (
                            <CarouselSlide
                                className='flex justify-around mt11 md-mt6 flex-1'
                                index={i}
                                key={`gallery-modal-${item?.id}`}>
                                <div
                                    className='flex flex-col'>
                                    <div>
                                        <TransformWrapper
                                            centerOnInit={true}
                                            initialScale={1.1}
                                            smooth={true}
                                            wheel={{ disabled: true }} >

                                            {({ zoomIn, zoomOut }) => (
                                                <>
                                                    <div className='flex flex-col md-height-100 absolute md-absolute-center-y top-0 left-0 right-0 md-right z5 mtn9 md-mt0 md-mr6 pointer-events-none'>
                                                        <div className='flex mt-auto mb5 md-mb6 md-pb5 justify-center md-justify-end'>
                                                            <Button
                                                                aria-label='Zoom out'
                                                                as='button'
                                                                className='bg-black p3 md-p5 mr3 white pointer-events-auto'
                                                                look='button'
                                                                onClick={() => zoomOut(0.2)}
                                                                renderIcon={<SubtractIcon />} />
                                                            <Button
                                                                aria-label='Zoom in'
                                                                as='button'
                                                                className='bg-black p3 md-p5 white pointer-events-auto'
                                                                look='button'
                                                                onClick={() => zoomIn(0.2)}
                                                                renderIcon={<AddIcon />} />
                                                        </div>
                                                    </div>
                                                    <div className='flex justify-around mix-blend-darken width-100'>
                                                        <TransformComponent>
                                                            <img
                                                                className='object-contain height-100 mr-auto ml-auto floorplan-image'
                                                                src={item?.px2} />
                                                        </TransformComponent>
                                                    </div>
                                                </>
                                            )}
                                        </TransformWrapper>
                                    </div>
                                </div>
                            </CarouselSlide>
                        );
                    })}
                </CarouselWrapper>

            </div>
        </Carousel>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default FloorplanModal;
